import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';

const LocationTypeForm = ({ fields, isNew, id, reload, onChange, setLoading, dataSelected }) => {
  const inputRef = useRef(null);
  const [companies, setCompanies] = useState([]);

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        name: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeLocationType(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 2) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Loại Địa Điểm này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Loại Địa Điểm này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createLocationType = async (data) => {
    try {
      const res = await ApiServices.createLocationType(data);
      if (res.data) {
        message.success('Thêm mới Loại Địa điểm thành công');
        return reload();
      } else {
        message.error('Thêm mới Loại Địa điểm thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới Loại Địa điểm thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateLocationType = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateLocationType(id, data);
      if (res.data) {
        message.success('Cập nhật Loại Địa điểm thành công');
        return reload();
      } else {
        message.error('Cập nhật Loại Địa điểm thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Loại Địa điểm thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createLocationType(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateLocationType(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      className='form-input-data'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã Loại Địa Điểm'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Loại Địa Điểm',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
          },
        ]}
      >
        <Input placeholder='Loại Địa Điểm' />
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên Loại Địa Điểm'
        rules={[
          {
            required: true,
            message: 'bạn phải nhập Tên Loại Địa Điểm',
          },
        ]}
      >
        <Input placeholder='Tên Loại Địa Điểm' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='name'
          onSearch={getCompanies}
        />
      </Form.Item>
      <Form.Item {...tailLayout} className=''>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { LocationTypeForm };
